import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegExp } from 'src/app/core/config/regex';
import { Appraisal, Approval, Approvalform, EmployeeAssesment, EmployeeLOne } from 'src/app/shared/models/appraisal';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-approval-ratings',
  templateUrl: './approval-ratings.component.html',
  styleUrls: ['./approval-ratings.component.scss']
})
export class ApprovalRatingsComponent {
  @Input() appraiseeId: number;
  @Input() appraisalId: number;
  @Input() status: string = "";
  @Input() isActive: boolean = false;
  @Output() rating = new EventEmitter<FormGroup>();
  @Output() emitWizardIndex = new EventEmitter<number>();
  @Input() employeeAssesment: EmployeeAssesment;

  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public approvals: Approval[] = [];
  public employeeDetails: any = {};
  public approvalForm!: FormGroup;
  public context: Context;
  public employees: EmployeeLOne[];
  public appraisals: Appraisal[];
  public isAssesmentCompleted: boolean = false;
  constructor(
    private fb: FormBuilder,
    private appraisalService: ApparaisalService,
    private toastr: ToastrService,
    private authService: AuthService,
    private commonService: CommonService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.isAssesmentCompleted = this.commonService.isAssesmentCompleted(this.employeeAssesment.status);
    this.employeeAssesment = this.employeeAssesment || {} as EmployeeAssesment;
    this.setObjectives([]);
    this.authService.getContext().subscribe((context) => {
      this.context = context;
    });
    this.setObjectives()
    this.getEmployeeObjectives();
    // this.getEmployeeAssessment();
  }
  public setObjectives(objectives?: Approval[]) {
    this.approvalForm = this.fb.group({
      objectives: this.fb.array([]),
    });
    if (objectives?.length > 0) {
      objectives.forEach(l => this.setObjectivesForm(l));
    }
  }

  get objectiveControls(): FormArray {
    return this.approvalForm.get("objectives") as FormArray;
  }

  private setObjectivesForm(objective?: Approval) {
    this.objectiveControls.push(this.fb.group({
      id: this.fb.control(objective?.id),
      objective: this.fb.control(objective?.objective, [Validators.required]),
      keyResult: this.fb.control(objective?.keyResult, [Validators.required]),
      selfRating: this.fb.control(objective?.selfRating, [Validators.required]),
      comments: this.fb.control(objective?.comments, [Validators.required]),
      year: this.fb.control(objective?.year, [Validators.required]),
      appraiseeId: this.fb.control(objective?.appraiseeId, [Validators.required]),
      appraiseeName: this.fb.control(objective?.appraiseeName),
      quarterId: this.fb.control(objective?.quarterId, [Validators.required]),
      quarterName: this.fb.control(objective?.quarterName),
      appraisalId: this.fb.control(objective?.appraisalId || this.appraisalId, [Validators.required]),
      appraisalName: this.fb.control(objective?.appraisalName),
      loneRating: this.fb.control(objective?.loneRating, [Validators.required, Validators.pattern(RegExp.numeric)]),
      loneRemarks: this.fb.control(objective?.loneRemarks, [Validators.required, Validators.pattern(RegExp.label)]),
      ltwoRating: this.fb.control(objective?.ltwoRating),
      ltwoRemarks: this.fb.control(objective?.ltwoRemarks),
    }));
  }

  public getEmployeeObjectives() {
    this.appraisalService.getObjectiveEmployees(this.appraiseeId, this.appraisalId).subscribe((app) => {
      this.approvals = app;
      this.setObjectives(app);
    });
  }

  public getEmployeeAssessment(): void {
    if (this.employeeAssesment?.appraisalId && this.employeeAssesment?.appraiseeId) {
      this.appraisalService.getAssessment(this.employeeAssesment.appraisalId, this.employeeAssesment.appraiseeId).subscribe({
        next: (employeeAssessment: EmployeeAssesment) => {
          this.employeeAssesment = employeeAssessment;
          this.setObjectives();
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('Failed to load employee assessment', 'Error');
        }
      });
    }
  }

  public saveApproval() {
    if (this.isActive) {
      return;
    }
    if (this.approvalForm.valid) {
      const objectives: Approval[] = this.approvalForm.value.objectives;
      if (objectives?.length > 0) this.updateApprovalItems(objectives);
      if (this.status === 'APPRAISEE_SUBMITTED') this.upsertAppraisalStatus();
    } else {
      this.toastr.error('Please enter the valid objective details');
    }
  }

  // private saveApprovalItems(items: Approval[]) {
  //   this.appraisalService.saveApproval(items, this.appraisalId, this.appraiseeId, true).subscribe({
  //     next: (objective: Message) => {
  //       if (!objective.failed) {
  //         this.commonService.setToastr(200, objective.text);
  //         // this.setObjectives();
  //         this.emitWizardIndex.emit(1);
  //         this.getEmployeeObjectives();
  //       } else {
  //         this.commonService.setToastr(500, objective.text);
  //       }
  //     },
  //     error: (error: HttpErrorResponse) => {
  //       this.toastr.error(error?.error?.error || error.error);
  //     }
  //   });
  // }

  private updateApprovalItems(items: Approval[]) {
    this.appraisalService.updateApproval(items, this.appraisalId, this.appraiseeId, true).subscribe({
      next: (objective: Message) => {
        this.commonService.setToastr(200, objective.text);
        this.emitWizardIndex.emit(1);
        this.getEmployeeObjectives();
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error?.error?.error || error.error);
      }
    });
  }
  validateRating(control: AbstractControl) {
    const rating = control.value;
    const isValid = !isNaN(parseFloat(rating)) && parseFloat(rating) >= 0 && parseFloat(rating) <= 10;
    const hasValidDecimalPlaces = /^(10(\.00?)?|[0-9](\.[0-9]{0,2})?)$/.test(rating);
    if (isValid && hasValidDecimalPlaces) {
      return null;
    } else {
      return { 'invalidRating': true };
    }
  }

  public upsertAppraisalStatus() {
    this.appraisalService.updateAppraisalStatus(this.employeeAssesment.id, 'LONE_RATED').subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          // this.emitWizardIndex.emit(1);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error?.error?.error || error.error);
      }
    });
  }
  focusNextField(event: KeyboardEvent): void {
    event.preventDefault(); // Prevent the default behavior (form submission)
    const form = (event.target as HTMLElement).closest('form'); // Find the parent form
    const inputs = Array.from(form?.querySelectorAll('input, textarea, select') || []); // Get all input fields
    const index = inputs.indexOf(event.target as HTMLInputElement); // Find the current input index
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLElement).focus(); // Focus the next input
    }
  }
}